<template>
  <div>
    <div class="page-header page-header-small">
      <parallax
        class="page-header-image"
        style="background-image: url('img/newEraField.jpg')"
      >
      </parallax>
      <div class="content-center">
        <div class="container">
          <h2 class="title">Elevate your perspective…</h2>
          <div class="text-center">
            <a href="https://www.facebook.com/NACS716" class="btn btn-primary btn-icon btn-round">
              <i class="fab fa-facebook-square"></i>
            </a>
            <a href="https://www.instagram.com/nacs716/" class="btn btn-primary btn-icon btn-round">
              <i class="fab fa-instagram"></i>
            </a>
            <a href="https://twitter.com/nacs716" class="btn btn-primary btn-icon btn-round">
              <i class="fab fa-twitter"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="section section-about-us">
      <div class="container">
          
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
      
            <h5 class="summarynacs">
              Aerial photography and video for both residential and civil needs.  Our staff has over 20 years in the service and contracting industry.  
              Call us at <a href="tel:716-479-2927">716.479.2927</a> for more information or assistance.  We are here to help!

            </h5>
          </div>
        </div>
        <div class="separator separator-primary"></div>
        <div class="section-story-overview">
          <div class="row">
            <div class="col-md-6">
              <div
                class="image-container image-left"
                style="background-image: url('img/giApartments.jpg')"
              >
                <!-- First image on the left side -->
                <p class="blockquote blockquote-primary">
                  "Above and beyond quality video and still shots.  The staff was professional, prompt and a pleasure to deal with.  Brought our marketing to the next level."
                  <br />
                  <br />
                  <small>-DMP</small>
                </p>
              </div>
              <!-- Second image on the left side of the article -->
              <div
                class="image-container"
                style="background-image: url('img/bg3.jpg')"
              ></div>
            </div>
            <div class="col-md-5">
              <!-- First image on the right side, above the article -->
              <div
                class="image-container image-right"
                style="background-image: url('img/bridges.jpg')"
              ></div>
              <!-- <h2 id="pricing">
                Pricing
              </h2>
              <h4>Basic Hourly Rate - $95.00/HR+</h4>
              <table>
                <tr class="theader">
                  <th></th>
                  <th>Up to 3,000 Sq Ft</th>
                  <th>Over 3,000 Sq Ft</th>
                </tr>
                <tr>
                  <td>Aerial - up to 15 photos</td>
                  <td>$275+</td>
                  <td>$275+</td>
                </tr>
                <tr class="theader">
                  <td>Additional Services</td>
                  <td></td>
                  <td></td>
                </tr>                
                <tr>
                  <td>Ground Ext. - up to 5 photos</td>
                  <td>$100+</td>
                  <td>$200+</td>
                </tr>
                <tr>
                  <td>Ground Int. - up to 10 photos</td>
                  <td>$150+</td>
                  <td>$250+</td>
                </tr>
                <tr>
                  <td>Complete Photo Package</td>
                  <td>$450+</td>
                  <td>$750+</td>
                </tr>
               <tr class="theader">
                  <td>Add On Video Services</td>
                  <td></td>
                  <td></td>
                </tr>                  
                <tr>
                  <td>Aerial - up to 3 minute video</td>
                  <td>$300+</td>
                  <td>$400+</td>
                </tr>
                <tr>
                  <td>Ground - up to 3 minute video</td>
                  <td>$200+</td>
                  <td>$300+</td>
                </tr>
                <tr>
                  <td>Photo & Video Package</td>
                  <td>$850+</td>
                  <td>$1,350+</td>
                </tr>
                <tr>
                  <td>Panoramic Photo Add On</td>
                  <td>$100+</td>
                  <td>$100+</td>
                </tr>                                
              </table> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="section section-team text-center">
      <div class="container">
        <h2 class="title">Here is our team</h2>
        <div class="team">
          <div class="row">
            <div class="col-md-4">
              <div class="team-player">
                <img
                  src="img/avatar.jpg"
                  alt="Thumbnail Image"
                  class="rounded-circle img-fluid img-raised"
                />
                <h4 class="title">Romina Hadid</h4>
                <p class="category text-primary">Model</p>
                <p class="description">
                  You can write here details about one of your team members. You
                  can give more details about what they do. Feel free to add
                  some <a href="#">links</a> for people to be able to follow
                  them outside the site.
                </p>
                <a href="#pablo" class="btn btn-primary btn-icon btn-round"
                  ><i class="fab fa-twitter"></i
                ></a>
                <a href="#pablo" class="btn btn-primary btn-icon btn-round"
                  ><i class="fab fa-instagram"></i
                ></a>
                <a href="#pablo" class="btn btn-primary btn-icon btn-round"
                  ><i class="fab fa-facebook-square"></i
                ></a>
              </div>
            </div>
            <div class="col-md-4">
              <div class="team-player">
                <img
                  src="img/ryan.jpg"
                  alt="Thumbnail Image"
                  class="rounded-circle img-fluid img-raised"
                />
                <h4 class="title">Ryan Tompson</h4>
                <p class="category text-primary">Designer</p>
                <p class="description">
                  You can write here details about one of your team members. You
                  can give more details about what they do. Feel free to add
                  some <a href="#">links</a> for people to be able to follow
                  them outside the site.
                </p>
                <a href="#pablo" class="btn btn-primary btn-icon btn-round"
                  ><i class="fab fa-twitter"></i
                ></a>
                <a href="#pablo" class="btn btn-primary btn-icon btn-round"
                  ><i class="fab fa-linkedin"></i
                ></a>
              </div>
            </div>
            <div class="col-md-4">
              <div class="team-player">
                <img
                  src="img/eva.jpg"
                  alt="Thumbnail Image"
                  class="rounded-circle img-fluid img-raised"
                />
                <h4 class="title">Eva Jenner</h4>
                <p class="category text-primary">Fashion</p>
                <p class="description">
                  You can write here details about one of your team members. You
                  can give more details about what they do. Feel free to add
                  some <a href="#">links</a> for people to be able to follow
                  them outside the site.
                </p>
                <a href="#pablo" class="btn btn-primary btn-icon btn-round"
                  ><i class="fab fa-google-plus"></i
                ></a>
                <a href="#pablo" class="btn btn-primary btn-icon btn-round"
                  ><i class="fab fa-youtube"></i
                ></a>
                <a href="#pablo" class="btn btn-primary btn-icon btn-round"
                  ><i class="fab fa-twitter"></i
                ></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <div class="section section-contact-us text-center">
      <div class="container">
        <h2 class="title">Want to work with us?</h2>
        <p class="description">Your project is very important to us.</p>
        
        
        <!-- Form that mike needs to get working -->
        <div class="row">
          <div v-if="!messageSent" class="col-lg-6 text-center ml-auto mr-auto col-md-8">
            <fg-input
              class="input-lg"
              placeholder="Name..."
              v-model="firstName"
              addon-left-icon="now-ui-icons users_circle-08"
            >
            </fg-input>
            <fg-input
              class="input-lg"
              placeholder="Email Here..."
              v-model="email"
              addon-left-icon="now-ui-icons ui-1_email-85"
            >
            </fg-input>
            <div class="textarea-container">
              <textarea
                class="form-control"
                name="name"
                rows="4"
                cols="80"
                v-model="message"
                placeholder="Type a message..."
              ></textarea>
            </div>
            <div class="send-button">
              <n-button type="primary" round block size="lg" @click="sendEmail()"
                >Send Message</n-button
              >
            </div>
            {{this.emailMessage}}
          </div>
          <div v-else class="col-lg-6 text-center ml-auto mr-auto col-md-8">
            Message Sent!
          </div>
        </div>

        <div class="mt-5">
          <img height="200" src="/img/FAA_logo.png" alt="FAA" class="rounded">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Button, FormGroupInput } from '@/components';
import axios from 'axios'

export default {
  name: 'landing',
  bodyClass: 'landing-page',
  components: {
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput
  },
  data() {
    return {
        firstName: '',
        email: '',
        message: '',
        emailMessage: '',
        messageSent: false
    };
  },
  methods: {
    sendEmail() {
      // code fragment
      if(this.firstName == '' || this.email == '') {
        this.emailMessage = 'Please enter at least your email and name!'
        return
      }
      
      this.emailSent = true
      axios({
        method: 'post',
        url: 'https://api.emailjs.com/api/v1.0/email/send',
        data: {
          service_id: 'google-march',
          template_id: 'template_bci8ihf',
          user_id: 'user_FJBy1MS1iRX8wXJvzcZWb',
          template_params: {
              'from_name': this.firstName,
              'message': this.message,
              'email': this.email
          }
        },
        headers: {
            'content-type': 'application/json',
        }
      })
      .then(resp => {
          this.emailMessage = ''
      })
      .catch(error => {
          this.messageSent = false
          this.emailMessage = 'Message Failed to Send'
      })
      this.emailMessage = 'Sending...'
      this.messageSent = true
      this.firstName = ''
      this.message = ''
      this.email = ''
    }    
  }
};
</script>
<style scoped>
table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td, th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

.theader {
  background-color: #dddddd;
}

.summarynacs {
  color: #328ACA;
}
</style>
